import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaPlus, FaVideo } from "react-icons/fa";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";
import TableEmptyState from "../ReusableComponents/TableEmptyState";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";



const Provas = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_provas, setLoadingprovas] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [provas, setprovas] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { processo_id, processo_name, inicio, simulado, has_blocks } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [prova_id, setRedacaoId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const Getprovas = async (page, search) => {

    let response = await Request.Get(`faculdade/get_provas/${processo_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.pagination.current_page == page) {

      setprovas(response.provas);

      setPagination(response.pagination);
      props.setState({total_exams:response.pagination.total_pages})

      setLoadingScreen(false);
      setLoadingprovas(false);


    }
  };

  const DeleteRedacao = async (prova_id) => {

    let response = await Request.Delete(`faculdade/delete_prova/${prova_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getprovas(pagination.current_page, search_oficial);



  };

  useEffect(() => {
    Getprovas(1, search_oficial);
  }, []);
  const user = useSelector((state) => state.AppReducer.user);

  let pesquisarTimeout = null;
  const history = useHistory();
  return (
    <>


            {/* <hr /> */}
            {loading_screen == false && <div>
                <div className="module-card-container">

                    <div className="module-breadcrumb">

                        <button
              className="breadcrumb-back"
              onClick={() =>
              props.setState({
                activeTab: -1
              })
              }>{t("dashboard")}


            </button>

                        <span>/</span>

                        <strong>{t("tests")}</strong>

                    </div>

                    <div className="module-title-row">

                        <div>

                            <h3 style={{ fontWeight: 'bold' }}>{`
                                ${t("tests")}
                            `}</h3>

                            <p>{t("ui_gerencie_as_provas_vinculadas_ao_processo_5ce1abb6")}

              </p>

                        </div>

                        <button
              className="btn-dashboard-modern"
              onClick={() =>
              props.setState({
                activeTab: -1
              })
              }>{`
                            ${t("legacy_dashboard")}
                        `}
            </button>

                    </div>

                    <div className="module-toolbar">

                        <Search
              placeholder={t("legacy_pesquisar_pelo_nome_da_prova")}
              ValueChange={(value) => {

                clearTimeout(pesquisarTimeout);

                setSearchOficial(value);

                pesquisarTimeout = setTimeout(() => {

                  let page = { ...pagination };

                  page.current_page = 1;

                  setPagination(page);

                  setLoadingprovas(true);

                  Getprovas(1, value);

                }, 500);

              }} />


            <div
              style={{
                display: 'flex',
                gap: '10px'
              }}>


                                {/* <Link
                to={`/provas/register_existing/${processo_id}`}
                className="btn-module-secondary"
                >
                <FaListAlt />
                Prova existente
                </Link> */


              }

                                <Link
                to={`/provas/register/${processo_id}`}
                className="btn-module-primary">


                                    <FaPlus />

                                    {t("action_new_test")}

                                </Link>

                            </div>

                    </div>
                    <div className="table-modern-card">
                        <div className="table-modern-scroll mb-0">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>

                                        <th>{t("label_name")}</th>
                                        <th>{t("legacy_numero_de_questoes")}</th>
                                        <th>Modelos</th>
                                        {has_blocks && <th>{t("label_block")}</th>}
                                        <th data-priority="3">{t("label_actions")}</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {loading_provas == false && provas.map((item, id) =>

                  <tr key={id}>
                                            <td><div className="redacao-name">

                                                <strong>
                                                    {item.name}
                                                </strong>

                                            </div></td>
                                            <td>

                                                <div className="redacao-preview">
                                                    {
                        item.questoes.
                        map((q) => q.type_questao === 'conjunto' ?
                        q.questoes.length :
                        1
                        ).
                        reduce((a, b) => a + b, 0)
                        }

                                                    {' '}{item.questoes.
                        map((q) => q.type_questao === 'conjunto' ?
                        q.questoes.length :
                        1
                        ).
                        reduce((a, b) => a + b, 0) == 1 ? 'questão' : 'questões'}
                                                </div>

                                            </td>
                                            {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}
                                            <td>

                                                <div className="redacao-preview">

                                                    {
                        item.random_layouts_max ?
                        item.provas.length :
                        '-'
                        }

                                                </div>

                                            </td>
                                            {has_blocks &&
                    <td>
                                                <span className={`trust-badge ${item.block ? 'trust-low' : 'trust-medium'}`}>
                                                    {item.block ? item.block.name : t("label_without_block")}
                                                </span>
                                            </td>}
                                            <td>

                                                <div className="actions-group">

                                                    <Link to={`/provas/show/${item.id}`}>

                                                        <button
                            className="action-btn warning">

                                                            <BsFillEyeFill />
                                                        </button>

                                                    </Link>

                                                    {(inicio > moment().add(10, 'minutes').format('YYYY-MM-DD HH:mm:ss') ||
                        user?.empresa?.online_proccess == false) &&


                        <Link to={`/provas/edit/${item.id}`}>

                                                            <button
                            className="action-btn info">

                                                                <MdModeEdit />
                                                            </button>

                                                        </Link>

                        }

                                                    {(inicio > moment().add(10, 'minutes').format('YYYY-MM-DD HH:mm:ss') ||
                        user?.empresa?.online_proccess == false) &&


                        <button
                          className="action-btn danger"
                          onClick={() => {

                            setRedacaoId(item.id);

                            setShowWarning(true);

                          }}>

                                                            <MdDelete />
                                                        </button>

                        }

                                                </div>

                                            </td>

                                        </tr>
                  )}

                                </tbody>
                            </table>
                            {loading_provas == true &&
              <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                    </div> */}
                                    <CircularProgress />
                                </div></div>

              }
                        </div>
                    </div>
                    {loading_provas == false && provas.length == 0 && <TableEmptyState title={t("empty_no_test_found")} icon="📚" />}

                    <Pagination
            className={pagination.last_page == 1 ? "hide" : ""}
            style={{ display: "flex", justifyContent: "flex-end" }}
            count={pagination.last_page}
            value={pagination.current_page}
            onChange={(_, value) => {
              setLoadingprovas(true);
              console.log(_, value);
              let page = { ...pagination };
              page.current_page = value;
              setPagination(pagination);
              Getprovas(value, search_oficial);
            }} />


                    {/* {this.state.andamento == true && <AvaliacaoAndamento get_prova={this.get_prova.bind(this)} {...this.props} />} */}
                </div>
            </div>}

            {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                {/* <div className="spinner-border text-primary" role="status"  >
            </div> */}
                <CircularProgress />
            </div></div>}

            <SweetAlert
        warning
        title={t("legacy_atencao")}
        onConfirm={() => {
          setShowWarning(false);
          setLoadingprovas(true);
          DeleteRedacao(prova_id);
          // this.delete_banner(this.state.banner_to_delete);
        }}
        onCancel={() => {
          setShowWarning(false);
        }}
        show={show_warning}
        confirmBtnText={t("legacy_sim_desejo_apagar")}
        cancelBtnText={t("legacy_cancelar")}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        showCancel={true}>{t("ui_ao_deletar_esta_prova_ele_nao_estara_mais_disponiv_7c8cffac")}


      </SweetAlert>



        </>);

};

export default Provas;
